const languageData = [
  {
    languageId: "english",
    locale: "en",
    name: "English",
    icon: "us",
  },
  {
    languageId: "thailand",
    locale: "th",
    name: "Thai",
    icon: "th",
  },
];
export default languageData;
